import { useAuth } from '../context/AuthContext';
import Layout from '../components/layout/Layout';
import { ClinicChat } from '../components/ClinicChat';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ChatPage() {
  const { user, token } = useAuth();

  return (
    <Layout>
      <div className="max-w-2xl mx-auto" data-testid="chat-page">
        <div className="bg-white border border-slate-200 rounded-xl overflow-hidden" style={{ height: 'calc(100vh - 140px)' }}>
          <ClinicChat
            apiBase="/api/chat"
            getHeaders={() => ({ Authorization: `Bearer ${token}` })}
            currentUserId={user?.id || ''}
            currentUserName={user?.name || user?.email || ''}
          />
        </div>
      </div>
    </Layout>
  );
}
